import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { ThemeProvider } from 'styled-components';
import { Provider} from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store';

import App from './App';

import GlobalStyle from './Theme/GlobalStyle';
import { theme } from './Theme/mainTheme';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
        <GlobalStyle />
        <BrowserRouter>
          <ThemeProvider theme={theme}>
              <App />
          </ThemeProvider>
        </BrowserRouter>
    </Provider>
  </React.StrictMode>,

  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
